/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC),
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

export const staticCode = {
  illumin8ContractId: {
    id: 'illumin8ContractId',
    label: 'Illumin8 Contract ID',
    length: 25,
    placeholder: 'Enter Illumin8 Contract ID',
  },
  illumin8SessionURLId: {
    id: 'illumin8SessionURLId',
    label: 'Illumin8 Provider',
    placeholder: 'Select Illumin8 Provider',
  },
  kadoeReferenceMaxLength: 20,
  vrmReviewDelayRangeError: 'Allowed range is 0-7',
  falseString: 'false',
  reminderInvalidMessage:
    'Reminder letter 2 must be greater than Reminder letter 1',
  reminderLetter2: 'reminderLetter2',
  reminderLetter1Text: '[x] days from the date of impoundment',
  reminderLetter2Text: '[X] days from the Reminder Letter 1 sent date',
  toggleConfirmationMessage: {
    enableIsBriefing: {
      hint: 'Enabling this toggle will allow HHD users to access the briefing tool.',
      confirmText: 'Are you sure you want to enable?',
    },
    disableIsBriefing: {
      hint: 'Disabling this toggle will not allow HHD users to access the briefing tool.',
      confirmText: 'Are you sure you want to disable?',
    },
  },
  controls: {
    isBriefingEnabled: {
      id: 'isBriefingEnabled',
      apiKey: 'isBriefingEnabled',
    },
  },
  paymentsMonitoringMessages: {
    enablingPaymentMonitoring: {
      enableHintMessage:
        'Enabling this toggle will allow users to monitor the part payments & unassigned payments',
      confirmText: 'Are you sure want to enable?',
    },
    disablingPaymentMonitoring: {
      enableHintMessage:
        'Disabling this toggle will not allow users to monitor the part payments & unassigned payments',
      confirmText: 'Are you sure want to disable?',
    },
  },
  hidePersonalMessages: {
    enablingHidePersonalMessages: {
      enableHintMessage:
        'Enabling this toggle will hide personal information for CEO Manager.',
      confirmText: 'Are you sure want to enable?',
    },
    disablingHidePersonalMessages: {
      enableHintMessage:
        'Disabling this toggle will not hide personal information for CEO Manager.',
      confirmText: 'Are you sure want to disable?',
    },
  },
  hide14DayLetterReviewMessages: {
    enablingHide14DayLetterReviewMessages: {
      hintMessage:
        'Enabling this toggle will activate the 14 Day Letter review screen.',
      confirmText: 'Are you sure want to enable?',
    },
    disablingHide14DayLetterReviewMessages: {
      hintMessage:
        'Disabling this toggle will deactivate the 14 Day Letter review screen.',
      confirmText: 'Are you sure want to disable?',
    },
  },
  isPaymentPlanEnabled: {
    isPaymentPlanEnabledText: 'isPaymentPlanEnabled',
    enablingPaymentPlan: {
      enableHintMessage:
        'Enabling this toggle will provide payment plan feature.',
      confirmText: 'Are you sure want to enable?',
    },
    disablingPaymentPlan: {
      enableHintMessage:
        'Disabling this toggle will remove the payment plan feature.',
      confirmText: 'Are you sure want to disable?',
    },
  },
  isAgentAssist: {
    isAgentAssistText: 'isAgentAssist',
    enablingAgentAssist: {
      enableHintMessage:
        'Enabling Agent Assist allows agents to securely assist customers with payments and makes this payment option available for customers. Do you want to enable it?',
      confirmText: 'Do you want to enable it?',
    },
    disablingAgentAssist: {
      enableHintMessage:
        'Disabling Agent Assist will prevent agents from assisting customers with payments and will make this payment option unavailable for customers. Do you want to disable it?',
      confirmText: 'Do you want to disable it?',
    },
  },
  kadoeLiveLookupReviewMessages: {
    isKADOELiveLookupEnabled: 'isKADOELiveLookupEnabled',
    enablingKadoeLiveLookupMessages: {
      hintMessage:
        'Enabling this toggle will activate the contract for an Immediate VQ5 response with DVLA',
      confirmText: 'Are you sure want to enable?',
    },
    disablingKadoeLiveLookupMessages: {
      hintMessage:
        'Disabling this toggle will deactivate the contract for an Immediate VQ5 response with DVLA',
      confirmText: 'Are you sure want to disable?',
    },
  },
  sendChallengeMessages: {
    enablingSendChallengeMessages: {
      enableHintMessage:
        'Enabling this toggle will send challenge status email & SMS alert to the customers.',
      confirmText: 'Are you sure want to enable?',
    },
    disablingSendChallengeMessages: {
      enableHintMessage:
        'Disabling this toggle will not send challenge status email & SMS alert to the customers.',
      confirmText: 'Are you sure want to disable?',
    },
  },
  debtMinimumBalance: 'debtMinimumBalance',
  warrantMinimumBalance: 'warrantMinimumBalance',
  marketInspectionMessages: {
    enablingMarketInspection: {
      enableHintMessage:
        'Enabling this toggle will allow users to inspect the market against the associated pitch and license.',
      confirmText: 'Are you sure want to enable?',
    },
    disablingMarketInspection: {
      enableHintMessage:
        'Disabling this toggle will not allow users to inspect the market against the associated pitch and license.',
      confirmText: 'Are you sure want to disable?',
    },
  },
  haloIntegrationWarrningText:
    'Enabling this toggle will allow users to raise HALO support tickers via BO.',
  haloIntegrationEnableConfirmationText: 'Are you sure want to enable?',
  haloIntegrationDisableConfirmationText:
    'Are you sure you want to disable the Halo Integration?',
  crAutoAssign: {
    enablingAutoAssign: {
      enableHintMessage:
        'Enabling this toggle will initiate the C&R system to auto assign the C&R jobs associated to this contract',
      confirmText: 'Are you sure want to enable?',
    },
    disablingAutoAssign: {
      enableHintMessage:
        'Disabling this toggle will stop the auto assignment process for the C&R jobs associated to this contract',
      confirmText: 'Are you sure want to disable?',
    },
    minTime: '00:01:00',
  },
  ignoreRepeatRepatCCWarrningText:
    "Enabling this feature will not change the status of a repeat rep at CC stage case to 'On Hold' when a WF task is created.",
  ignoreRepeatRepatCCEnableConfirmationText: 'Are you sure wish to enable?',
  ignoreRepeatRepatCCDisableConfirmationText: 'Are you sure wish to disable?',
  disableIgnoreRepeatRepatCCWarrningText:
    "Disabling this feature will change the status of a repeat rep at CC stage case to 'On Hold' when a WF task is created.",
  autoAssignInfoNotification:
    'Enabling this setting will un-assign the task on user logout',
  myWorkItems: {
    id: 'isWorkItemEnabled',
    label: 'My Work Items',
    apiKey: 'isWorkItemEnabled',
    enablingMyWorkItems: {
      hintMessage:
        'Enabling My Work Items will allow users associated with this contract or council to view and manage their work items from their main menu. Do you want to enable it?',
      confirmText: 'Enable',
      cancelText: 'Cancel',
    },
    disablingMyWorkItems: {
      hintMessage:
        'Disabling My Work Items will not allow users associated with this contract or council to view and manage their work items from their main menu. Do you want to Disable it?',
      confirmText: 'Disable',
      cancelText: 'Cancel',
    },
  },
  autoAssignment: {
    id: 'isAutoAssignmentEnabled',
    label: 'Auto-Assignment',
    apiKey: 'isAutoAssignmentEnabled',
    enablingAutoAssignment: {
      hintMessage:
        'Enabling Auto-Assignment will automatically distribute applications to logged in BO users for this contract. Once enabled both Manual and automatic assignment methods will be available. Do you want to enable it?',
      confirmText: 'Enable',
      cancelText: 'Cancel',
    },
    disablingAutoAssignment: {
      hintMessage:
        'Disabling Auto-Assignment will switch the process back to manual mode for this contract. Do you want to disable it?',
      confirmText: 'Disable',
      cancelText: 'Cancel',
    },
  },
  autoDebtConfiguration: 'autoDebtConfiguration',
  autoWarrantConfiguration: 'autoWarrantConfiguration',
  autoBailiffConfiguration: 'autoBailiffConfiguration',
  debtSecuredEmailAddress: 'debtSecuredEmailAddress',
  debtStandardEmailAddress: 'debtStandardEmailAddress',
  debtScheduleTypeId: 'debtScheduleTypeId',
  warrantSecuredEmailAddress: 'warrantSecuredEmailAddress',
  warrantStandardEmailAddress: 'warrantStandardEmailAddress',
  warrantScheduleTypeId: 'warrantScheduleTypeId',
  bailiffScheduleTypeId: 'bailiffScheduleTypeId',
  aira: {
    enablingAira: {
      enableHintMessage:
        'Enabling this toggle will activate the AIRA feature for this contract',
      confirmText: 'Are you sure want to enable?',
    },
    disablingAira: {
      enableHintMessage:
        'Disabling this toggle will remove the AIRA feature for this contract',
      confirmText: 'Are you sure want to disable?',
    },
    isAIRAEnabled: 'isAIRAEnabled',
  },
  simpleadminhidePII: {
    enablingsimpleadminhidePII: {
      enableHintMessage:
        'Enabling this toggle will hide the PII data from simple admin users',
      confirmText: `Are you sure you want to enable?`,
    },
    disablingsimpleadminhidePII: {
      enableHintMessage:
        'Disabling this toggle will allow the simple admin users view the PII data',
      confirmText: 'Are you sure you want to disable?',
    },
    isSimpleAdminHidePII: 'isSimpleAdminHidePII',
  },
  debtPeController: {
    isDebtPEControllerEnabled: 'isDebtPEControllerEnabled',
    enablingDebtPEController: {
      enableHintMessage:
        'Enabling this toggle will activate the persistent evader filtering in the debt registration batches',
      confirmText: 'Are you sure want to enable?',
    },
    disablingDebtPEController: {
      enableHintMessage:
        'Disabling this toggle will remove the persistent evader filtering in the debt registration batches',
      confirmText: 'Are you sure want to disable?',
    },
  },
  debtorReview: {
    isDebtorReviewEnabled: 'isDebtorReviewEnabled',
    enablingDebtorReview: {
      enableHintMessage:
        'Enabling this feature will show the Debtor Review screen for cases at the Enforcement Agents',
      confirmText: 'Are you sure want to enable?',
    },
    disablingDebtorReview: {
      enableHintMessage:
        'Disabling this feature will hide the Debtor Review screen for cases at the Enforcement Agents',
      confirmText: 'Are you sure want to disable?',
    },
  },
  hotspotMessages: {
    enablingHotspot: {
      enableHintMessage:
        'Enabling this toggle will allow you mark the Hotspots per contract.',
      confirmText: 'Are you sure want to enable?',
    },
    disablingHotspot: {
      enableHintMessage:
        'Disabling this toggle will not allow you mark the Hotspots per contract.',
      confirmText: 'Are you sure want to disable?',
    },
    isHotspotEnabled: 'isHotspotEnabled',
  },
  discountRepReject14Days: {
    enablingDiscountRepReject14Days: {
      enableHintMessage:
        'Enabling this feature will allow representation reject actioned and discount period re-offered for 21 days',
      confirmText: 'Are you sure want to enable?',
    },
    disablingDiscountRepReject14Days: {
      enableHintMessage:
        'Disabling this feature will allow representation reject actioned and discount period re-offered for 21 days',
      confirmText: 'Are you sure want to disable?',
    },
    isDiscountRepReject21Days: 'isDiscountRepReject21Days',
  },
  chatBot: {
    enablingChatBot: {
      enableHintMessage:
        'Enabling this feature will allow the citizen users to interact with a chat bot',
      confirmText: 'Are you sure want to enable?',
    },
    disablingChatBot: {
      enableHintMessage:
        'Disabling this feature will not allow the citizen users to interact with a chat bot',
      confirmText: 'Are you sure want to disable?',
    },
    isChatBotEnabled: 'isChatBotEnabled',
  },
  emailIntegration: {
    characterRestriction: 'Maximum 200 characters only allowed',
    checkAvailability: 'Check Availability',
    emailAvailable: 'Available',
    emailNotAvailable: 'Not Available',
  },
  vatPercentageErrorMessage:
    'The value of the VAT percentage cannot exceed 100',
  customerEmailResponse: {
    enablingCustomerEmailResponse: {
      enableHintMessage:
        'Enabling this feature allows citizen users to choose their email preferences',
      confirmText: 'Are you sure want to enable?',
    },
    disablingCustomerEmailResponse: {
      enableHintMessage:
        'Disabling this feature will hide the email preference option from the citizen users',
      confirmText: 'Are you sure want to disable?',
    },
    customerEmailResponseEnabled: 'customerEmailResponseEnabled',
  },
  printImages: {
    enablingPrintImages: {
      enableHintMessage:
        'Enabling this feature will include images in the print batch output alongside the CSV data file',
      confirmText: 'Are you sure want to enable?',
    },
    disablingPrintImages: {
      enableHintMessage:
        'Disabling this feature will not include images in the print batch output alongside the CSV data file',
      confirmText: 'Are you sure want to disable?',
    },
    isPrintImageEnabled: 'isPrintImageEnabled',
  },
  fuzzyVRM: {
    enablingFuzzyVRM: {
      enableHintMessage:
        "Enabling this feature will automatically trigger an additional lookup only if the initial Illumin8 search returns 'No results found'",
      confirmText: 'Are you sure you want to enable?',
    },
    disablingFuzzyVRM: {
      enableHintMessage:
        'Disabling this feature will stop the system from performing any automatic follow-up lookup',
      confirmText: 'Are you sure you want to disable?',
    },
    isFuzzyVRMEnabled: 'isFuzzyVRMEnabled',
  },
  normalizedContractTypes: {
    aira: 'aira',
    apply: 'apply',
    ecn: 'ecn',
    fpn: 'fpn',
    pcn: 'pcn',
    scotlandPcn: 'scotlandpcn',
    privateLand: 'privateland',
    summarisation: 'summarisation',
    abandonedVehicle: 'abandonedvehicle',
  },
  normalizedTribunalNames: {
    popla: 'popla',
  },
  contractFeatures: {
    toggleOptions: 'toggleOptions',
    organisationName: 'organisationName',
    contractType: 'contractType',
    contractName: 'contractName',
    contractId: 'contractId',
    illumin8ContractName: 'illumin8ContractName',
    country: 'country',
    currency: 'currency',
    timezone: 'timezone',
    region: 'region',
    tribunal: 'tribunal',
    poplaCode: 'poplaCode',
    troTmoMapPath: 'troTmoMapPath',
    chargeRate: 'chargeRate',
    printBatchSchedule: 'printBatchSchedule',
    skipDays: 'skipDays',
    dvlaRequest: 'dvlaRequest',
    kadoeContractReference: 'kadoeContractReference',
    offlineCaseCount: 'offlineCaseCount',
    contractSenderEmail: 'contractSenderEmail',
    correspondenceApprovalLimit: 'correspondenceApprovalLimit',
    contractEmail: 'contractEmail',
    debtWarrantSequence: 'debtWarrantSequence',
    hhdAutoLogout: 'hhdAutoLogout',
    hhdTestPrint: 'hhdTestPrint',
    autoAssign: 'autoAssign',
    reportFaults: 'reportFaults',
    reportingType: 'reportingType',
    commonReporting: 'commonReporting',
    faultSpecificReporting: 'faultSpecificReporting',
    addFaultName: 'addFaultName',
    doubleJeopardyCctv: 'doubleJeopardyCctv',
    createTask: 'createTask',
    clampAndRemoval: 'clampAndRemoval',
    workflowTaskAutoAssign: 'workflowTaskAutoAssign',
    myWorkItems: 'myWorkItems',
    automateDebt: 'automateDebt',
    automateWarrant: 'automateWarrant',
    automateEmergencyAgency: 'automateEmergencyAgency',
    permissionType: 'permissionType',
    applyContractInformation: 'applyContractInformation',
    emailIntegration: 'emailIntegration',
    kadoeHoldReview: 'kadoeHoldReview',
    selfServiceReporting: 'selfServiceReporting',
    isAgentAssist: 'isAgentAssist',
    defaultNonWorkingDays: 'defaultNonWorkingDays',
    illumin8SessionId: 'illumin8SessionId',
    deleteEvidence: 'deleteEvidence',
    londonCouncilsAutoTransfer: 'londonCouncilsAutoTransfer',
    barcode: 'barcode',
    abandonedVehicleRetentionDays: 'abandonedVehicleRetentionDays',
  },
  witnessStatement: {
    id: 'isWitnessStatementRequired',
    label: 'Witness Statement Required',
    tooltipText:
      'When enabled, a witness statement is required for cases associated with this PCN contract.',
    enablingWitnessStatement: {
      confirmText: 'Are you sure you want to enable?',
    },
    disablingWitnessStatement: {
      confirmText: 'Are you sure you want to disable?',
    },
  },
  allowHHDLoginWithoutTestPrint: {
    id: 'isHHDLoginWithoutTestPrint',
    label: 'Allow HHD Login Without Test Print',
    tooltipText:
      'When enabled, HHD users can log in and access the HHD without completing the mandatory test print process. When disabled, users must complete the configured number of test print attempts before proceeding.',
    enablingAllowHHDLoginWithoutTestPrint: {
      confirmText: 'Are you sure want to enable?',
    },
    disablingAllowHHDLoginWithoutTestPrint: {
      confirmText: 'Are you sure want to disable?',
    },
  },
  preDebtEaSplit: {
    id: 'isPreDebtEaSplitEnabled',
    label: 'Pre-debt Distribution',
    tooltipText:
      'When enabled, pre-debt cases are distributed to Enforcement Agents, with separate files created and stored in EA-specific folders. When disabled, the standard single-file process applies.',
    enablingPreDebtEaSplit: {
      hintMessage:
        'Enabling this toggle will distribute pre-debt cases to Enforcement Agents, with separate files created and stored in EA-specific folders.',
      confirmText: 'Are you sure you want to enable?',
    },
    disablingPreDebtEaSplit: {
      hintMessage:
        'Disabling this toggle will apply the standard single-file process for pre-debt cases.',
      confirmText: 'Are you sure you want to disable?',
    },
  },
  preDebt: {
    id: 'isPreDebtEnabled',
    enablingPreDebt: {
      hintMessage:
        'Enabling this toggle will allow the system to include the eligible cases in the pre debt stat doc batch',
      confirmText: 'Are you sure you want to enable?',
    },
    disablingPreDebt: {
      hintMessage:
        'Disabling this toggle will not allow the system to include the eligible cases in the pre debt stat doc batch',
      confirmText: 'Are you sure you want to disable?',
    },
  },
  citizenPortalChallenge: {
    id: 'isCitizenPortalChallengeEnabled',
    enablingCitizenPortalChallenge: {
      hintMessage: `Enabling this toggle will make the 'Challenge' function visible on the Citizen Portal for all cases linked to the selected contract`,
      confirmText: 'Are you sure you want to enable?',
    },
    disablingCitizenPortalChallenge: {
      hintMessage: `Disabling this toggle will hide the 'Challenge' function on the Citizen Portal for all cases linked to the selected contract`,
      confirmText: 'Are you sure you want to disable?',
    },
  },
  permissionEmailDuplicate:
    'Please ensure all email addresses are valid and not duplicated.',
  permissionEmailValidate: 'is not a valid email address',
  defaultNonWorkingDays: {
    id: 'isDefaultNonWorkingDay',
    label: 'Default Non-Working Days',
    apiKey: 'IsDefaultNonWorkingDay',
    enablingDefaultNonWorkingDays: {
      hintMessage: `Enabling this toggle will allow group non working days to be automatically applied to this contract`,
      confirmText: 'Are you sure you want to enable?',
    },
    disablingDefaultNonWorkingDays: {
      hintMessage: `Disabling this toggle will not allow group non working days to be automatically applied to this contract`,
      confirmText: 'Are you sure you want to disable?',
    },
  },
  boManagerLocationZone: {
    id: 'isBOManagerLocationZoneEnabled',
    enablingBoManagerLocationZone: {
      hintMessage:
        'Enabling this toggle will allow BO Managers to access Location/Zone configuration menus.',
      confirmText: 'Are you sure you want to enable it?',
    },
    disablingBoManagerLocationZone: {
      hintMessage:
        'Disabling this toggle will prevent BO Managers from seeing Location/Zone configuration menus.',
      confirmText: 'Are you sure you want to disable it?',
    },
  },
  deleteEvidence: {
    id: 'isDeleteEvidenceEnabled',
    label: 'Delete Evidence',
    tooltipText:
      'Enabling the toggle will allow the user to delete the selected attachment',
    enablingDeleteEvidence: {
      confirmText: 'Are you sure you want to enable?',
    },
    disablingDeleteEvidence: {
      confirmText: 'Are you sure you want to disable?',
    },
  },
  selfLetterApproval: {
    id: 'isSelfLetterApprovalEnabled',
    label: 'Self Letter Approval',
    tooltipText:
      'Enabling this toggle will allow BO Managers and QC BO Users to approve or reject letters they have created.',
    enablingSelfLetterApproval: {
      confirmText: 'Are you sure you want to enable?',
    },
    disablingSelfLetterApproval: {
      confirmText: 'Are you sure you want to disable?',
    },
  },
  repeatWFAutomatic: {
    id: 'isRepeatWFAutomaticEnabled',
    label: 'Repeat WF Automatic',
    tooltipText:
      'If enabled, tasks with the same VRM will be automatically assigned to the same Back Office user if one already exists.',
    enablingRepeatWFAutomatic: {
      confirmText: 'Are you sure you want to enable?',
    },
    disablingRepeatWFAutomatic: {
      confirmText: 'Are you sure you want to disable?',
    },
  },
  londonCouncilsAutoTransfer: {
    id: 'isLondonCouncilsAutoTransferEnabled',
    label: 'London Councils Auto Transfer',
    tooltipText:
      'If enabled, when TEC batch files are generated they are sent to London Councils via sftp.',
    enablingLondonCouncilsAutoTransfer: {
      confirmText: 'Are you sure you want to enable?',
    },
    disablingLondonCouncilsAutoTransfer: {
      confirmText: 'Are you sure you want to disable?',
    },
  },
  foreignDebtBlobStorage: {
    id: 'isForeignDebtBlobStorageEnabled',
    label: 'Blob Storage for Foreign Debt Batch',
    tooltipText:
      'When enabled, generated Foreign Debt batch files are stored in blob storage and processed via the scheduled SFTP job',
  },
  boManagerBriefingAccess: {
    id: 'isBOManagerBriefingAccessEnabled',
    enablingBoManagerBriefingAccess: {
      hintMessage:
        'Enabling this feature should allow BO Manager users to access the Briefing menu',
      confirmText: 'Are you sure you want to enable?',
    },
    disablingBoManagerBriefingAccess: {
      hintMessage:
        'Disabling this feature will remove BO Manager users\u2019 access to the Briefing menu.',
      confirmText: 'Are you sure you want to disable?',
    },
  },
  infoRequestScreenMessages: {
    id: 'isInfoRequestScreenEnabled',
    enablingInfoRequestScreen: {
      hintMessage:
        "Enabling this toggle will make the 'Info Requested' tab visible in Workflow Manager and Rep Review.",
      confirmText: 'Are you sure you want to enable?',
    },
    disablingInfoRequestScreen: {
      hintMessage:
        "Disabling this toggle will hide the 'Info Requested' tab from Workflow Manager and Rep Review",
      confirmText: 'Are you sure you want to disable?',
    },
  },
  allowCEOCancellationOnHHD: {
    id: 'isCEOCancelationHHDEnabled',
    enablingAllowCEOCancellationOnHHD: {
      hintMessage:
        'Enabling this toggle will allow CEOs to cancel PCNs directly from the handheld device',
      confirmText: 'Are you sure you want to enable?',
    },
    disablingAllowCEOCancellationOnHHD: {
      hintMessage:
        'Disabling this toggle will prevent CEOs from cancelling PCNs on the handheld device.',
      confirmText: 'Are you sure you want to disable?',
    },
  },
  enableVRMManualDoubleCheck: {
    id: 'isVRMDoubleCheckEnabled',
    enablingEnableVRMManualDoubleCheck: {
      hintMessage:
        'Enabling this toggle will require the CEO to manually re-enter the VRM before proceeding to the Issuance phase.',
      confirmText: 'Are you sure you want to enable?',
    },
    disablingEnableVRMManualDoubleCheck: {
      hintMessage:
        'Disabling this toggle will allow the CEO to proceed to Issuance without a VRM re-check.',
      confirmText: 'Are you sure you want to disable?',
    },
  },
  isCEOCancelationHHDEnabled: {
    enabling: {
      hintMessage:
        'Enabling this toggle will allow CEOs to cancel PCNs directly from the handheld device',
      confirmText: 'Are you sure you want to enable?',
    },
    disabling: {
      hintMessage:
        'Disabling this toggle will prevent CEOs from cancelling PCNs on the handheld device.',
      confirmText: 'Are you sure you want to disable?',
    },
  },
  isVRMDoubleCheckEnabled: {
    enabling: {
      hintMessage:
        'Enabling this toggle will require the CEO to manually re-enter the VRM before proceeding to the Issuance phase.',
      confirmText: 'Are you sure you want to enable?',
    },
    disabling: {
      hintMessage:
        'Disabling this toggle will allow the CEO to proceed to Issuance without a VRM re-check.',
      confirmText: 'Are you sure you want to disable?',
    },
  },
  simpleAppealPackEnabled: {
    enabling: {
      hintMessage:
        'Enabling this setting will exclude staff-related event history entries from the generated Appeal Pack',
      confirmText: 'Are you sure you want to enable?',
    },
    disabling: {
      hintMessage:
        'Disabling this setting will not exclude staff-related event history entries from the generated Appeal Pack.',
      confirmText: 'Are you sure you want to disable?',
    },
  },
  suspensionManagement: {
    id: 'isSuspensionManagementEnabled',
    label: 'Suspension Management',
    tooltipEnabled:
      'Disabling this option will hide the Suspensions tab and remove suspension-related configuration for this PCN contract.',
    tooltipDisabled:
      'Enabling this option will display the Suspensions tab and allow suspension-related configuration for this PCN contract.',
    enabling: {
      title: 'Enable Suspension Management?',
      message:
        'Enabling this option will display the Suspensions tab and allow suspension\u2011related configuration for this PCN contract.',
      confirmQuestion: 'Do you want to enable it?',
      confirmText: 'Enable',
    },
    disabling: {
      title: 'Disable Suspension Management?',
      message:
        'Disabling this option will hide the Suspensions tab and remove suspension\u2011related configuration for this PCN contract.',
      confirmQuestion: 'Do you want to disable it?',
      confirmText: 'Disable',
    },
  },
  // ─── US-249736: CEO Task Assignment Type ────────────────────────────────
  suspensionTaskAssignment: {
    assignToSpecificCeo: 'assignToSpecificCeo',
    assignToAnyAvailableCeo: 'assignToAnyAvailableCeo',
    options: [
      {
        value: 'assignToSpecificCeo',
        label: 'Assign to Specific CEO',
        description: 'Manually select a CEO to handle this task.',
      },
      {
        value: 'assignToAnyAvailableCeo',
        label: 'Assign to Any Available CEO',
        description: 'Automatically assign to any available CEO in the system.',
      },
    ],
    noCeoMessage:
      'The CEO has not been created yet. Once created, you can select the CEO using this option.',
    errorLoadingCeos: 'Unable to load officer list. Please try again.',
  },
  pcnCeoMapping: {
    id: 'isCEOMappingEnabled',
    label: 'PCN CEO Mapping',
    tooltipEnabled:
      'PCN CEO Mapping is enabled. Suspension tasks can be assigned to mapped PCN contract CEOs.',
    tooltipDisabled:
      'Enable PCN CEO Mapping to allow suspension tasks to be assigned to mapped PCN contract CEOs.',
    enabling: {
      title: 'Enable PCN CEO Mapping?',
      message:
        'Enabling PCN CEO Mapping will allow suspension tasks to be assigned to mapped PCN contract CEOs for all suspension applications.',
      confirmQuestion: 'Do you want to enable it?',
      confirmText: 'Enable',
    },
    disabling: {
      title: 'Disable PCN CEO Mapping?',
      message:
        'Disabling PCN CEO Mapping will prevent suspension tasks from being assigned to mapped PCN contract CEOs for suspension applications.',
      confirmQuestion: 'Do you want to disable it?',
      confirmText: 'Disable',
    },
  },
  batchPrinting: {
    id: 'isBatchPrintingEnabled',
    label: 'Batch Printing',
    tooltipEnabled:
      'Approved and paid scratch card applications move to Batch Send status and become eligible for serial number generation.',
    tooltipDisabled:
      'Applications continue with the existing scratch card process and are excluded from batch printing.',
    enabling: {
      title: 'Enable Batch Printing?',
      message:
        'Enabling Batch Printing will move approved and paid scratch card applications to Batch Send status, making them eligible for serial number generation.',
      confirmQuestion: 'Do you want to enable it?',
      confirmText: 'Enable',
    },
    disabling: {
      title: 'Disable Batch Printing?',
      message:
        'Disabling Batch Printing will keep applications on the existing scratch card process, excluded from batch printing.',
      confirmQuestion: 'Do you want to disable it?',
      confirmText: 'Disable',
    },
  },
  kadoeHoldReview: {
    id: 'isKADOEHoldReviewEnabled',
    label: 'KADOE Hold Review',
    tooltipEnabled:
      'Enabling this will move unenforceable cases to Hold for review. If disabled, these cases will be cancelled.',
    tooltipDisabled:
      'Enabling this will move unenforceable cases to Hold for review. If disabled, these cases will be cancelled.',
    enabling: {
      title: 'Enable KADOE Hold Review?',
      confirmQuestion: 'Are you sure you want to enable?',
      confirmText: 'Enable',
    },
    disabling: {
      title: 'Disable KADOE Hold Review?',
      confirmQuestion: 'Are you sure you want to disable?',
      confirmText: 'Disable',
    },
  },
  selfServiceReporting: {
    id: 'isSelfServiceReportingEnabled',
    label: 'Self-Service Reporting',
    tooltipEnabled:
      'Enables authorised users to create and manage self-service reports for this contract. Existing Standard Reports are not affected. Additional user permissions are required to access the report creation capability.',
    tooltipDisabled:
      'Enables authorised users to create and manage self-service reports for this contract. Existing Standard Reports are not affected. Additional user permissions are required to access the report creation capability.',
    enabling: {
      title: 'Enable Self-Service Reporting?',
      hintMessage:
        'This will make the Self-Service Report Builder available for this contract to users who have the required report-authoring permission. Existing Standard Reports will not be affected',
      confirmQuestion: 'Are you sure you want to enable?',
      confirmText: 'Enable',
    },
    disabling: {
      title: 'Disable Self-Service Reporting?',
      hintMessage:
        'This will prevent users from creating new self-service reports for this contract. Existing Standard Reports will not be affected. Published self-service reports will be available and drafts will be discarded.',
      confirmQuestion: 'Are you sure you want to disable?',
      confirmText: 'Disable',
    },
  },
  configurableTrackingAccess: {
    id: 'isTrackingAccessEnabled',
    label: 'Configurable Tracking Access',
    tooltipText:
      'When enabled, Tracking menu access can be configured per user',
    enablingConfigurableTrackingAccess: {
      confirmText: 'Are you sure you want to enable?',
    },
    disablingConfigurableTrackingAccess: {
      confirmText: 'Are you sure you want to disable?',
    },
  },
  peLoginSignature: {
    id: 'isLoginSignatureEnabled',
    optionLabel: 'Login Signature',
    optionDataTestId: 'isPELoginSignature',
    tooltipText:
      'Requires officer signature capture during PE login for this contract.',
  },
  enforcementMap: {
    id: 'isMapEnabled',
    optionLabel: 'Map UI',
    optionDataTestId: 'isEnforcementMap',
    tooltipText: 'Enables the Red Route map‑based enforcement interface.',
  },
  coreEnforcementLayers: {
    id: 'isLayersEnabled',
    optionLabel: 'Core Layers',
    optionDataTestId: 'isCoreEnforcementLayers',
    tooltipText:
      'Enables core TfL enforcement layers (zones, red route, enforceability).',
  },
  mapLayerControls: {
    id: 'isMapLayerControlsEnabled',
    optionLabel: 'Layer Controls',
    optionDataTestId: 'isMapLayerControls',
    tooltipText: 'Allows officers to turn map layers on/off using defaults.',
  },
  mapSearch: {
    id: 'isMapSearchEnabled',
    optionLabel: 'Map Search',
    optionDataTestId: 'isMapSearch',
    tooltipText: 'Enables map search by junction, address, and postcode.',
  },
  startObservationPcnFromMap: {
    id: 'isStartPCNFromMapEnabled',
    optionLabel: 'Start from Map',
    optionDataTestId: 'isStartObservationPCNFromMap',
    tooltipText: 'Allows Observation or PCN to be started from a map location.',
  },
  mapMarkersAndRecordDrilldown: {
    id: 'isMapDrilldownEnabled',
    optionLabel: 'Map Markers',
    optionDataTestId: 'isMapMarkersRecordDrilldown',
    tooltipText:
      '        Displays PCNs, Observations, and Defects on the map with drilldown.',
  },
  enforceabilityWarningsAndDetails: {
    id: 'isWarningsDetailsEnabled',
    optionLabel: 'Enforceability Checks',
    optionDataTestId: 'isEnforceabilityWarningsDetails',
    tooltipText:
      'Shows warnings and restriction details for unenforceable zones.',
  },
  blueBadgeCapture: {
    id: 'isBlueBadgeCaptureEnabled',
    optionLabel: 'Blue Badge',
    optionDataTestId: 'isBlueBadgeCapture',
    tooltipText: 'Enables specific Blue Badge capture fields.',
  },
  complianceAndAlerts: {
    id: 'isPermitVRMAlertsEnabled',
    optionLabel: 'Exempt VRM Alert',
    optionDataTestId: 'isComplianceAlerts',
    tooltipText: 'Alerts officers when an exempt/permitted VRM is detected.',
  },
  toggleTabs: {
    defaultTab: {
      key: 'default',
      label: 'Default',
      testId: 'tab_default',
    },
    parkingEnforcementTab: {
      key: 'parkingEnforcement',
      label: 'Parking Enforcement',
      testId: 'tab_parkingEnforcement',
    },
  },
  splitPrint: {
    id: 'isSplitPrintEnabled',
    optionLabel: 'Split Print',
    optionDataTestId: 'isSplitPrintEnabled',
    enablingSplitPrint: {
      confirmText: 'Are you sure you want to enable?',
    },
    disablingSplitPrint: {
      confirmText: 'Are you sure you want to disable?',
    },
    tooltipText:
      'Enable Split Print to allow letters to be separated into Main and Secondary outputs. Secondary letters will be stored separately and sent via the Integrity FTP process.',
  },
}

/**
 * Normalises a contract type string for comparison — lowercased, whitespace stripped.
 * @param {string} contractType
 * @returns {string}
 */
export const formatToNormalized = (contractType) => {
  return contractType?.toString()?.toLowerCase()?.replace(/\s+/g, '')
}

export const isScotlandPcnContractType = (contractType) => {
  return (
    formatToNormalized(contractType) ===
    staticCode?.normalizedContractTypes?.scotlandPcn
  )
}

export const isPcnFamilyContractType = (contractType) => {
  const normalizedContractType = formatToNormalized(contractType)

  return [
    staticCode?.normalizedContractTypes?.pcn,
    staticCode?.normalizedContractTypes?.ecn,
    staticCode?.normalizedContractTypes?.scotlandPcn,
  ].includes(normalizedContractType)
}
